import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Employment tabs component for switching between Current and Previous employment
 * @param {Object} props - Component props
 * @param {Array} props.tabs - Array of tab objects with label and key
 * @param {string} props.activeTab - Key of the currently active tab
 * @param {Function} props.onTabClick - Callback when tab is clicked
 */
const EmploymentTabs = ({ tabs, activeTab, onTabClick }) => {
  // If only one tab, show as heading instead
  if (tabs.length === 1) {
    // Convert "CURRENT EMPLOYMENT" to "Current Employment"
    const headingText = tabs[0].label
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');

    return (
      <div className="employment-tabs">
        <div className="employment-tabs--heading">{headingText}</div>
      </div>
    );
  }

  return (
    <div className="employment-tabs">
      <div className="employment-tabs--list">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={classNames('employment-tabs--tab', {
              'employment-tabs--tab-active': tab.key === activeTab,
            })}
            onClick={() => onTabClick(tab.key)}
            type="button"
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

EmploymentTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabClick: PropTypes.func.isRequired,
};

export default EmploymentTabs;
